/** Sent so the LLM reacts to an upload; never show this text to the visitor. */
export const isInternalFileUploadedMarker = (content: unknown): boolean =>
  typeof content === 'string' && content.trim().toLocaleLowerCase() === '[file_uploaded]'

export const stripInternalFileUploadedMarker = (content: string): string =>
  content.replace(/\[file_uploaded\]/gi, '').trim()
